export const AUTH_TOKEN_KEY = 'token';
const LP_TOKEN_COOKIE_KEY = 'lp_token';
export const USER_STORAGE_KEY = 'vibe-user-storage';

type PersistedUserStorage = {
  state?: {
    token?: unknown;
    user?: {
      token?: unknown;
    } | null;
  };
};

export const normalizeAuthToken = (value: unknown): string | null => {
  if (typeof value !== 'string') return null;

  const token = value.trim();
  if (!token || token === 'null' || token === 'undefined') return null;

  return token;
};

const getPersistedAuthToken = (): string | null => {
  try {
    const raw = localStorage.getItem(USER_STORAGE_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw) as PersistedUserStorage;
    return normalizeAuthToken(parsed.state?.token) || normalizeAuthToken(parsed.state?.user?.token);
  } catch {
    return null;
  }
};

const getCookieAuthToken = (): string | null => {
  const tokenPair = document.cookie
    .split(';')
    .map((item) => item.trim())
    .find((item) => item.startsWith(`${LP_TOKEN_COOKIE_KEY}=`));

  if (!tokenPair) return null;

  try {
    return normalizeAuthToken(decodeURIComponent(tokenPair.slice(LP_TOKEN_COOKIE_KEY.length + 1)));
  } catch {
    return null;
  }
};

const expireAuthCookie = (domain?: string) => {
  if (typeof document === 'undefined') return;

  const domainPart = domain ? `; domain=${domain}` : '';
  document.cookie = `${LP_TOKEN_COOKIE_KEY}=; path=/${domainPart}; max-age=0; SameSite=Lax`;
};

const getAuthCookieDomains = () => {
  if (typeof window === 'undefined') return [];

  const hostname = window.location.hostname;
  const domains = new Set<string>();

  if (hostname) {
    domains.add(hostname);
  }

  if (hostname.includes('coveauto.ai')) {
    domains.add('.coveauto.ai');
    domains.add('coveauto.ai');
  }

  if (hostname.includes('shijieboya.cn')) {
    domains.add('.shijieboya.cn');
    domains.add('shijieboya.cn');
  }

  return [...domains];
};

export const clearStoredAuthTokenSources = () => {
  localStorage.removeItem(AUTH_TOKEN_KEY);
  localStorage.removeItem(USER_STORAGE_KEY);

  expireAuthCookie();
  getAuthCookieDomains().forEach((domain) => expireAuthCookie(domain));
};

export const getStoredAuthToken = (options: { repair?: boolean } = {}): string | null => {
  const token = normalizeAuthToken(localStorage.getItem(AUTH_TOKEN_KEY));
  if (token) return token;

  const recoveredToken = getPersistedAuthToken() || getCookieAuthToken();
  if (recoveredToken && options.repair !== false) {
    localStorage.setItem(AUTH_TOKEN_KEY, recoveredToken);
  }

  return recoveredToken;
};
